import classes from "./Order.module.scss";

const Order = ({ customerName, tableNum, orderDate, orderNote, items }) => {
  return (
    <div className={classes.Order}>
      <div className={classes.OrderInfo}>
        <h4>{customerName}</h4> . <h4>{tableNum}</h4>
      </div>
      <p className={classes.OrderDate}>{orderDate}</p>
      <div className={classes.OrderNote}>
        <p className={classes.NoteHeader}>Note</p>
        <p className={classes.NoteBody}>{orderNote}</p>
      </div>
      <div className={classes.Items}>
        {items.map((item) => {
          return (
            <div className={classes.Item}>
              <p className={classes.ItemName}>{item.name}</p>
              <p className={classes.ItemQuantity}>{item.quantity}</p>
              {item.size && <p className={classes.ItemSize}>{item.size}</p>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Order;
